import React from 'react'
import { TranslationKeys } from 'locales/translationKeys'
import { Text } from 'components/Text'
import useTranslation from 'next-translate/useTranslation'
import { ParagraphAndList } from '../ParagraphAndList'

export type CollapsibleContentSectionProps = {
  number?: string
  title?: TranslationKeys
  paragraphsAndLists?: {
    paragraphs?: TranslationKeys[]
    lists?: TranslationKeys[]
    orderedLists?: TranslationKeys[]
    link?: string
  }[]
  nestingLevel?: number
}

export const CollapsibleContentSection = ({
  number,
  title,
  paragraphsAndLists,
  nestingLevel = 0,
}: CollapsibleContentSectionProps) => {
  const { t } = useTranslation()

  return (
    <>
      {title && (
        <Text weight="bold" css={{ paddingLeft: `${nestingLevel * 24}px` }}>
          {number} {t(title)}
        </Text>
      )}
      {paragraphsAndLists &&
        paragraphsAndLists?.map(({ paragraphs, lists, orderedLists, link }, index) => (
          <ParagraphAndList
            nestingLevel={nestingLevel}
            paragraphs={paragraphs}
            list={lists}
            orderedList={orderedLists}
            link={link}
            key={index}
          />
        ))}
    </>
  )
}

CollapsibleContentSection.displayName = 'CollapsibleContentSection'
